import { initGeneral } from "../modules/general.js";
import { initAccordion } from "../modules/accordion.js";
import { initLoanCalculator } from "../modules/calc-loan.js";

jQuery(document).ready(function ($) {
	initGeneral();
	initAccordion();
	initLoanCalculator();
});
